<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import isMobile from 'ismobilejs'
import { backgroundList } from '@/constants/data'
import LABELS from '@/constants/labels'

export default {
  name: 'AddBackground',
  data() {
    return {
      dataBg: null,
      selectedBg: null,
      currentBg: null,
    }
  },

  methods: {
    ...mapActions('settings', ['setBackground', 'saveToStorage', 'setTexts']),
    handleSelectBgColor(item) {
      this.selectedBg = item
    },

    handleShowModalDeleteSpecialFont() {
      const hasSpecialFont =
        this.modules.texts.filter(item => item.fontFamily === 'Cabin Condensed')
          .length > 0
      return (
        !!this.selectedBg.logo &&
        !this.modules.background.logo &&
        hasSpecialFont
      )
    },

    handleShowPopupConfirmData() {
      if (this.handleShowModalDeleteSpecialFont()) {
        this.showPopupConfirmDeleteDataText()
      } else {
        this.handleNextStep()
      }
    },

    handleNextStep() {
      this.setBackground(this.selectedBg)
      this.saveToStorage()
      this.$router.push({ name: 'preview' })
    },

    showPopupConfirmDeleteDataText() {
      this.$nextTick(() => {
        this.$refs.confirmDeleteDataText &&
          this.$refs.confirmDeleteDataText.show({
            title: this.mappingLabels.deleteModalTitle,
            message: this.mappingLabels.deleteModalMessage,
            textCancelButton: this.mappingLabels.cancelText,
            textSubmitButton: this.mappingLabels.confirmText,
          })
      })
    },

    submitDeleteDataText() {
      this.selectedBg = this.currentBg
      this.setBackground(this.currentBg)
      this.saveToStorage()
      this.$refs.confirmDeleteDataText.hide()
    },
  },

  computed: {
    ...mapGetters('settings', [
      'getOrientation',
      'getBackground',
      'getTexts',
      'getStamps',
      'getAvatars',
    ]),
    ...mapState('settings', ['modules']),
    mappingLabels() {
      return LABELS
    },
    isMobile() {
      return !isMobile().any
    },
  },
  created() {
    this.dataBg = backgroundList[this.getOrientation]
    this.parentTab = this.getTemplate
    this.selectedBg = this.getBackground
    this.currentBg = this.getBackground
  },
}
</script>

<template>
  <div>
    <s-header :hasPreview="true">{{ mappingLabels.backgroundTitle }}</s-header>
    <div class="background-page">
      <div class="background-page_container">
        <div class="wrap-content">
          <div class="background-page_image">
            <!-- <a @click="showPopupConfirmDeleteDataText()">
              <div class="delete-avt__btn">
                <img :src="require('@/assets/images/avatar/trash_avt.svg')" />
                <span>やり直す</span>
              </div>
            </a> -->
            <s-preview
              :textDraw="getTexts"
              :stampDraw="getStamps"
              :backgroundDraw="selectedBg"
              :avatarDraw="getAvatars"
            />
          </div>

          <div class="background-page_content">
            <div class="setion-group" v-for="group of dataBg" :key="group.id">
              <p class="sub-title">{{ group.title }}</p>
              <div class="background-select" v-dragscroll="isMobile">
                <s-choose-item-bg
                  v-for="item in group.backgrounds"
                  :key="item.id"
                  :data="item"
                  :selected="selectedBg.id === item.id"
                  @click-item="handleSelectBgColor"
                />
              </div>
            </div>
          </div>
          <s-navigate-bar
            class="navigate-bar-fixed"
            @leftClick="$router.push({ name: 'preview' })"
            @rightClick="handleShowPopupConfirmData"
            >{{ mappingLabels.decideAndBackToPreviewText }}</s-navigate-bar
          >
        </div>
      </div>
      <s-modal-confirm
        ref="confirmDeleteDataText"
        @submit="submitDeleteDataText"
      ></s-modal-confirm>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'background.scss';
</style>
